import {
  message
} from 'antd';
import { AxiosError } from 'axios';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import CreateEmployeeAssign from 'common/components/CreateEmployeeAssign';
import { getStaffAssignService } from 'common/services/extends/staffAssign';

const EmployeeAssignDetail: React.FC<ActiveRoles> = (props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  /* States */
  const idParams = Number(searchParams.get('id'));

  /* Queries */
  const { data: staffAssignDetailRes, isLoading: detailLoading } = useQuery(
    ['get-staff-assign-detail', idParams],
    () => getStaffAssignService(idParams),
    {
      enabled: !!idParams,
      onError: (error: unknown) => {
        if (error instanceof AxiosError) {
          message.error(
            error.response?.data?.message || t('message.anErrorHasOccurred')
          );
        }
      },
    }
  );

  return (
    <CreateEmployeeAssign
      {...props}
      data={staffAssignDetailRes}
      loading={detailLoading}
    />
  );
};

export default EmployeeAssignDetail;
